function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 5,
  fill: "#64B5F6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.632 17.474v-6.316L18.474 8l-3.158 3.158v2.105H9V28h18.947V17.474h-6.315zm-8.422 8.42h-2.105V23.79h2.105v2.105zm0-4.21h-2.105V19.58h2.105v2.105zm0-4.21h-2.105v-2.106h2.105v2.106zm6.316 8.42h-2.105V23.79h2.105v2.105zm0-4.21h-2.105V19.58h2.105v2.105zm0-4.21h-2.105v-2.106h2.105v2.106zm0-4.21h-2.105v-2.106h2.105v2.105zm6.316 12.63h-2.105V23.79h2.105v2.105zm0-4.21h-2.105V19.58h2.105v2.105z",
  fill: "#E3F2FD"
});

function SvgInfrastructure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgInfrastructure;